export enum RoleEnum {
  USER_INFO = 1,
  COUPON_POINT = 2,
  PARTY_CANCEL = 4,
  PARTY_INFO = 8,
  USERLOG = 16,
  KAKAO = 32,
  COMMENT = 64,
  CHAT = 128,
  BLACK = 256,
  ADMIN_LOG = 512,
  ADMIN_SET = 1024,
  EXCEL_DOWNLOAD = 2048,
  SUNSET = 4096,
  COMMENT_DELETE = 8192,
  BLACK_DELETE = 16384,
  USER_MONEY = 32768,
  USER_BILL = 65536,
  DASH = 131072,
  UPLUS = 262144,
}

export enum AdminLogEnum {
  //코멘트
  INSERT_COMMENT = 0,
  UPDATE_COMMENT = 1,
  DELETE_COMMENT = 2,

  //블랙리스트
  ADD_BLACK = 10,
  DELETE_BALCK = 11,
  UPDATE_BLACK = 12,

  //파티
  CHANGE_MEMBERCNT = 15,
  CHANGE_PARTY_SHAREID = 16,
  CHANGE_ENDDATE = 17,
  EXPIRE_PARTYALARM = 18,
  UPDATE_PARTY_INVITE_INFO = 19,
  PARTY_BREAK_NOPENALTY_DAY = 20,
  PARTY_BREAK_NOPENALTY = 21,
  PARTY_BREAK_PENALTY = 22,
  PARTY_BREAK_NOPAY = 23,
  PARTY_EXIT_NOPENALTY = 24,
  PARTY_EXIT_NOPENALTY_DAY = 25,
  PARTY_EXIT_PENALTY = 26,
  PARTY_EXIT_REWARD = 27,
  CANCEL_MATCHING = 28,
  CANCEL_PARTY_EXIT = 29,
  CHANGE_USER_SHAREID = 300,
  PARTY_REJOIN  = 10001,
  UPDATE_RINGCODE  = 10002,
  CHANGE_PARTY_AUTO_EXTEND = 10003,


  //포인트
  TAKE_POINT = 30,
  DELETE_POINT = 31,
  CANCEL_POINT_SCHEDULE = 32,
  TAKE_MANY_POINT = 33,

  //쿠폰
  TAKE_COUPON = 40,
  DELETE_COUPON = 41,
  TAKE_MANY_COUPON = 42,
  USE_COUPON = 43,

  //권한관리
  UPDATE_ADMIN = 50,
  ADD_ADMIN = 51,
  DELETE_ADMIN = 52,
  DELETE_RIGHT = 53,
  ADD_RIGHT = 54,
  UPDATE_RIGHT = 55,

  //알림톡 보내기
  SEND_KAKAO = 60,
  SEND_LMS = 61,

  //링머니
  DELETE_MONEY = 70,
  UPDATE_PRIORITY_MONEYPAY = 71,
  PAY_NOW = 72,
  ADMIN_WITHDRAW = 73,

  //결제관리
  PAY_SCHEDULE = 80,
  PAY_REFUND = 81,
  PAY_LASTPAY = 82,
  DELETE_FAILPAY = 83,

  //유저관리
  UPDATE_SUBPHONE = 90,
  ACCEPT_RE_REGISTER = 91,
  UPDATE_REGINFO = 92,
  RESEND_INVITE = 93,
  UPDATE_EXTRAINFO = 94,
  UPDATE_USERMAIL = 95,
  UPDATE_MACRO = 96,
  REG_MACRO = 97,
  UPDATE_BANK = 98,

  //채팅관리
  EXCUTE_CHAT_REPORT = 100,

  //임시계정
  ADD_TMPACCOUNT = 110,
  UPDATE_TMPACCOUNT = 111,
  DELETE_TMPACCOUNT = 112,
  DELETE_FORCE_ERRLIST = 113,
  DELETE_ERRLIST = 114,

  //일몰
  ADD_SUNSET = 115,
  UPDATE_SUNSET = 116,
  DELETE_SUNSET = 117,

  //팝업시스템
  ADD_POPUP = 120,
  UPDATE_POPUP = 121,
  COMPLETE_POPUP = 122,
  ADD_POPUP_MESSAGE = 123,
  UPDATE_POPUP_MESSAGE = 124,
  DELETE_POPUP_MESSAGE = 125,
  ADD_POPUP_TYPE = 126,
  DELETE_POPUP = 127,

  //FAQ
  ADD_FAQ = 140,
  UPDATE_FAQ = 141,
  DELETE_FAQ = 142,
  ADD_CATEGORY = 143,
  UPDATE_CATEGORY = 144,
  DELETE_CATEGORY = 145,
  ADD_KEYWORD = 146,
  UPDATE_KEYWORD = 147,
  DELETE_KEYWORD = 148,

  //version
  UPDATE_VERSION = 150,
  UPDATE_MAINTENANCE = 151,
  UPDATE_CERTI = 152,
  UPDATE_BILL_ORDER = 153,
  UPDATE_BLOCK = 154,
  UPDATE_SYSTEM_DEF = 155,

  //공지사항, 이용약관, 이벤트
  ADD_NOTICE = 161,
  UPDATE_NOTICE = 162,
  DELETE_NOTICE = 163,
  ADD_RULE = 167,
  UPDATE_RULE = 168,
  DELETE_RULE = 169,
  ADD_EVENT = 170,
  UPDATE_EVENT = 171,
  MAKE_SENDPUSH = 172,

  //콜라보
  UPDATE_UPLUS = 180,
  UPDATE_UPLUS_PROCESS = 181,
  UPDATE_YOUTUBE_STATE = 182,

  //매치파티
  MATCH_PARTY_SAVE = 190,
  MATCH_EMAIL_SAVE = 191,
  MATCH_EMAIL_COMMENT_UPDATE = 192,
  MATCH_EMAIL_PW_UPDATE = 193,

  MATCH_SUBS_SAVE = 194,

  //체크리스트
  CHECK_SAVE = 200,
  CHECK_UPDATE = 201,
  CHECK_DELETE = 202,
}

export enum LoginEnum {
  OK = 200,
  ERR_PASSWORD = 400,
  ERR_EMAIL = 401,
  TEMP_EMAIL = 403,
  NOT_CAHNGE_TEMP = 410,
  NEED_VALID_NUM = 411,
  INVALID_NUM = 412,
}

export enum UplusState {
  MATCH = 1,
  MATCHING = 2,
  SUCCESS = 3,
  FINISH = 4,
  FAIL = 5,
  CANCEL = 6,
}

export enum ActLog {
  ReqIns = 1, // 파티 요청
  ReqOk = 2, // 파티 요청 성공
  ReqCancel = 3, // 파티 요청 취소
  ReqFail = 4, // 파티 요청 실패 (아마 기간 내 요청 실패)
  ReqFailPay = 5, // 파티 결제실패로인한 결제 실패

  Login = 100, // 로그인
  ChangePW = 101, // 비번 변경
  ChangeHP = 102, // certi
  ChangeCard = 103, // 카드 변경
  ChangeAcc = 104, // bankAccountSave
  ChangeNick = 105, // 닉네임 변경
  ChangeShare = 106, // shareid change regmembshareid
  changeSubHP = 107, // 서브핸폰 번호 변경
  Escape = 108, // 탈퇴 (escape로 바꿔야 할 듯..
  FailChangeAcc = 109, // 계좌 변경 실패

  // ================= index packet action log 앞으로 추가될 곳은 여기
  register = 1001, //
  changeprovider = 1002, //
  mailcb = 1003, //
  mailsecond = 1004,
  friendInvite = 1005,
  setMacroExtraMemPw = 1006,
  saveMemberLimit = 1007,
  NewMemberPoint  = 1008,
  mailread        = 1009,

  // ================== user packet action log 앞으로 추가될 곳은 여기
  logout = 2001, // 로그 아웃
  pinsave = 2002, // pin 저장
  payday = 2003, // 결제일 변경
  cardaccountdel = 2004,
  withdraw = 2005, // 출금
  couponreg = 2006, // 쿠폰 등록
  collabo = 2007, // 콜라보
  pointreg = 2008, // 포인트 등록
  sendtemp = 2009, // subpin
  validCard = 2010, // 카드 인증
  getStamp = 2011,
  retriveStamp = 2012,
  delSubPhone = 2013, // 카드 인증
  delUserEmail = 2014, // 카드 인증
  sendNcookie = 2015, // 네이버 쿠키쿠폰 전송
  changeCardOrder = 2016, // 마스터 서브 카드 순서 바꾸기
  makesubuser = 2017, // 서브 유저 만들기
  changesubuser = 2018, // 서브 유저 변경하기
  useMoneyFirst = 2019, // 링키드 머니 우선사용
  
  // ================== party packet action log 앞으로 추가될 곳은 여기
  save = 3001,
  join = 3002,
  modify = 3003,
  exit = 3004,
  break = 3005,
  hide = 3006,
  couponuse = 3007,
  acc_mailcreate = 3008,
  user_mailsave = 3009,
  sendinvite = 3010,
  validEmail = 3011,
  ssetagree = 3012,
  reqTempAcc = 3013,
  saveErrParty = 3014,
  confirmmbshareid = 3015,
  userreport = 3016,
  uplusRequest = 3017,
  uplusReqCancel = 3018,
  uplusSave = 3019,
  UplusJoin = 3020,
  UplusBreak = 3021,
  expelled = 3022,
  checkEmail = 3023,
  Be_Broken = 3024,
  sendAlarm = 3025,
  setExtraMemPw = 3026,
  setMacroStatus = 3027,

  viewPartyLogin = 4000,
  eventPageClick = 4001,
  sendAlarmLinkid = 4002,
}

export enum PacketLock {
  PAY_ALL = 1,
  MANUAL_WITHDRAW = 2,
}

export enum MeiliTypeEnum {
  FAQ = 'FAQ'
}